var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHackerNewsThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF6600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26074 6.26087H25.739V25.7391H6.26074V6.26087ZM11.1331 9.88703L15.2007 17.5068V22.513H16.7651V17.5988L20.8695 9.88703H19.1394L16.7099 14.7092C16.5872 14.9669 16.4675 15.2153 16.351 15.4546C16.2344 15.6939 16.1271 15.9178 16.0289 16.1264C15.9921 16.0282 15.9491 15.9209 15.9001 15.8043C15.851 15.6877 15.7958 15.5681 15.7344 15.4454C15.7221 15.4209 15.7099 15.3933 15.6976 15.3626C15.6853 15.3319 15.6669 15.2982 15.6424 15.2614C15.6056 15.1632 15.5626 15.0681 15.5135 14.9761C15.4645 14.884 15.4215 14.7951 15.3847 14.7092L12.992 9.88703H11.1331Z",
    fill: "white"
  })));
}

export default SvgHackerNewsThumb;